module.exports = __webpack_public_path__ + "assets/img/1.898a5287.jpg";